/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { PipelineNode } from '../models/pipeline-node';

/**
 * UI Delivery Pipeline Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiDeliveryPipelineControllerService extends __BaseService {
  static readonly getDeliveryPipelineUsingGETPath =
    '/cc-ui/v1/delivery-pipeline/{stackName}';
  static readonly updateDeliveryPipelineUsingPUTPath =
    '/cc-ui/v1/delivery-pipeline/{stackName}';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getDeliveryPipeline
   * @param stackName stackName
   * @return OK
   */
  getDeliveryPipelineUsingGETResponse(
    stackName: string,
  ): __Observable<__StrictHttpResponse<Array<PipelineNode>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/delivery-pipeline/${encodeURIComponent(String(stackName))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PipelineNode>>;
      }),
    );
  }
  /**
   * getDeliveryPipeline
   * @param stackName stackName
   * @return OK
   */
  getDeliveryPipelineUsingGET(
    stackName: string,
  ): __Observable<Array<PipelineNode>> {
    return this.getDeliveryPipelineUsingGETResponse(stackName).pipe(
      __map((_r) => _r.body as Array<PipelineNode>),
    );
  }

  /**
   * updateDeliveryPipeline
   * @param params The `UiDeliveryPipelineControllerService.UpdateDeliveryPipelineUsingPUTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `pipelineNodes`: pipelineNodes
   *
   * @return OK
   */
  updateDeliveryPipelineUsingPUTResponse(
    params: UiDeliveryPipelineControllerService.UpdateDeliveryPipelineUsingPUTParams,
  ): __Observable<__StrictHttpResponse<Array<PipelineNode>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.pipelineNodes;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/delivery-pipeline/${encodeURIComponent(
          String(params.stackName),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PipelineNode>>;
      }),
    );
  }
  /**
   * updateDeliveryPipeline
   * @param params The `UiDeliveryPipelineControllerService.UpdateDeliveryPipelineUsingPUTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `pipelineNodes`: pipelineNodes
   *
   * @return OK
   */
  updateDeliveryPipelineUsingPUT(
    params: UiDeliveryPipelineControllerService.UpdateDeliveryPipelineUsingPUTParams,
  ): __Observable<Array<PipelineNode>> {
    return this.updateDeliveryPipelineUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as Array<PipelineNode>),
    );
  }
}

module UiDeliveryPipelineControllerService {
  /**
   * Parameters for updateDeliveryPipelineUsingPUT
   */
  export interface UpdateDeliveryPipelineUsingPUTParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * pipelineNodes
     */
    pipelineNodes: Array<PipelineNode>;
  }
}

export { UiDeliveryPipelineControllerService };
